
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.594 10.253c-.57 0-1.051.367-1.232.875h-1.83V9.57l1.484-.664a.437.437 0 00.265-.402v-3.5V5L7 6.458v3.795l.656-.293v1.606c0 .241.196.437.438.437h2.268a1.31 1.31 0 001.232.875c.724 0 1.312-.588 1.312-1.312 0-.724-.588-1.313-1.312-1.313z"}}),_c('path',{attrs:{"d":"M8.875 4.34V2.75h1.83a1.31 1.31 0 001.232.875 1.314 1.314 0 000-2.625c-.57 0-1.05.367-1.231.875H8.438A.437.437 0 008 2.313v1.65l-.703-.303a.435.435 0 00-.344 0l-.703.303v-1.65a.437.437 0 00-.438-.438H3.545A1.31 1.31 0 002.312 1a1.314 1.314 0 000 2.625c.57 0 1.051-.367 1.232-.875h1.831v1.59c-.762.327-1.514.651-1.52.655l3.27 1.453 3.27-1.453c-.006-.004-.758-.328-1.52-.656zM3.625 5.003v3.5c0 .175.104.334.265.402l1.485.664v1.56h-1.83a1.31 1.31 0 00-1.232-.876 1.314 1.314 0 000 2.625c.57 0 1.05-.367 1.231-.875h2.268a.437.437 0 00.438-.437V9.96l.656.293V6.458L3.626 5l-.001.003z"}})])
          )
        }
      }
    